import { useTheme } from "@mui/material";

const CloseToastIcon = (): JSX.Element => {
  const theme = useTheme();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15M15 15L5 5.00001"
        stroke={theme.palette.otherTextTertiary.main}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CloseToastIcon;
